export const TRIAS_ADDRESS = {
  56: '0xa4838122c683f732289805FC3C207Febd55BabDD',
  97: '0x71B404ccBB6b349f7bB8767953078Be58325B8ed',
  42: '0xF9178e68DcF76028215a98992797a48Db2826A9a'
}

export const STAKE_ADDRESS = {
  56: '0x96f9738FC0dFC9e1f59818B819A6fCDf1f0f7e15',
  97: '',
  42: ''
}

export const DASHI_ADDRESS = {
  56: '0x0Bfcb3fe912602Ab8482616E3717370f831a42f6',
  42: '0xF9178e68DcF76028215a98992797a48Db2826A9a',
  97: ''
}

export const TRIAS_DASHI_ADDRESS = {
  56: '0xa4838122c683f732289805FC3C207Febd55BabDD',
  42: '0x7d363e3df7a53055B5B393EA909805008E5E361B',
  97: ''
}

export const ANTI_CONTACT_ADDRESS = {
  56: '0xcc3544246260773E13EdC1a3f593599E987e2478',
  42: '0x417e0BebA6AB25A45f19b20adb38A9D20667EA9B',
  97: ''
}

export const TRIAS4_CONTACT_ADDRESS = {
  56: '0x502C19d82DdB953bAbF342b1D5E63cb2e353f697',
  42: '',
  97: '0xeBD96CC1F0d2D12484a3ac0224e9663470b67dFe'
}